import React from 'react';
import PropTypes from 'prop-types';

const SportsMMAIcon = ({ className, color = 'black' }) => {
  return (
    <svg
      className={className}
      fill="none"
      height="42"
      viewBox="0 0 42 42"
      width="42"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.25 35C12.25 35.9625 13.0375 36.75 14 36.75H28C28.9625 36.75 29.75 35.9625 29.75 35V29.75H12.25V35Z"
        fill={color}
      />
      <path
        d="M31.5 12.25C30.5375 12.25 29.75 13.0375 29.75 14V8.75C29.75 6.825 28.175 5.25 26.25 5.25H12.25C10.325 5.25 8.75 6.825 8.75 8.75V18.9C8.75 19.1275 8.7675 19.355 8.82 19.5825L10.22 26.5825C10.3775 27.405 11.095 27.9825 11.935 27.9825H29.75C30.7125 27.9825 31.6575 27.2125 31.85 26.2675L33.1975 19.565C33.2325 19.355 33.25 19.1275 33.25 18.9V15.75V14C33.25 13.0375 32.4625 12.25 31.5 12.25ZM29.75 18.55C29.75 18.7775 28.63 24.5 28.63 24.5H13.37C13.37 24.5 12.25 18.795 12.25 18.55V8.75H26.25V17.5H29.75V18.55Z"
        fill={color}
      />
      <path d="M24.5 12.25H14V17.5H24.5V12.25Z" fill={color} />
    </svg>
  );
};

SportsMMAIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export default SportsMMAIcon;

